module.exports = __webpack_public_path__ + "img/google.eacf935b.png";